import { render, staticRenderFns } from "./PaymentStatus.vue?vue&type=template&id=75163f03&scoped=true&"
import script from "./PaymentStatus.vue?vue&type=script&lang=js&"
export * from "./PaymentStatus.vue?vue&type=script&lang=js&"
import style0 from "./PaymentStatus.vue?vue&type=style&index=0&id=75163f03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75163f03",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VIcon,VRow})
